module.exports = __webpack_public_path__ + "img/Pier_pass_config_mobile_transparent_3.162d01bb.gif";